import { setupNotificationHubConfig } from './notification-hub-config';

setupNotificationHubConfig({
    url: global?.NotificationHubConfig?.url,
    icon: global?.NotificationHubConfig?.icon,
    audio: global?.NotificationHubConfig?.audio,
    expires_in: global?.NotificationHubConfig?.expires_in,
});
